const uuidv4Pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

class SceneEditController {
  constructor ($log, $q, HistoryService, SceneService, SceneCollectionService, ColorService) {
    'ngInject'

    this._$log = $log
    this._$q = $q
    this._HistoryService = HistoryService
    this._SceneService = SceneService
    this._SceneCollectionService = SceneCollectionService
    this._ColorService = ColorService

    this.formValid = true
  }

  $onInit () {
    this.edit = angular.isDefined(this.id)

    this.org = {
      name: '',
      orientation: 'l',
      color: this._ColorService.getRandomColor(),
      clientId: ''
    }
    this.scene = angular.copy(this.org)

    this.colors = this._ColorService.getColors()

    if (this.edit) {
      // Load scene object and collection
      this._$q.all([
        this._SceneService.get(this.id),
        this._SceneCollectionService.getSceneCollectionsForScene(this.id)
      ])
        .then(([scene, collection]) => {
          this.org = scene
          this.scene = angular.copy(this.org)

          this.sceneContent = collection
        })
    }
  }

  validateClientIdInput () {
    const isValid = this.validateClientId(this.scene.clientId)
    if (this.clientForm && this.clientForm.clientId) {
      this.clientForm.clientId.$setValidity('uuid', isValid)
    }
    this.formValid = isValid
  }

  validateClientId (clientId) {
    return !clientId || uuidv4Pattern.test(clientId)
  }

  isSaveDisabled () {
    return !this.formValid || this.scene.name === undefined || this.scene.name.length === 0 ||
    (
      this.scene.name === this.org.name &&
      this.scene.orientation === this.org.orientation &&
      this.scene.clientId === this.org.clientId &&
      this.scene.color === this.org.color
    )
  }

  submit (valid) {
    if (!valid || !this.formValid) {
      return
    }

    if (!this.validateClientId(this.scene.clientId)) {
      this._$log.log(`SceneEdit [submit] failed. Invalid clientId: ${this.scene.clientId}`)
      return
    }

    if (this.edit) {
      this.save()
    } else {
      this.add()
    }
  }

  add () {
    this._SceneService.create(this.scene)
      .then(() => this._HistoryService.goBackOrTo('manager.settings'))
      .catch(error => this._$log.log(`SceneEdit [add] failed. Scene was ${JSON.stringify(this.scene)}. Error: ${error}`))
  }

  save () {
    this._SceneService.update(this.scene)
      .then(() => this._HistoryService.goBackOrTo('manager.settings'))
      .catch(error => this._$log.log(`SceneEdit [save] failed. Scene was ${JSON.stringify(this.scene)}. Error: ${error}`))
  }

  remove () {
    this._SceneService.delete(this.id)
      .then(() => this._HistoryService.goBackOrTo('manager.settings'))
      .catch(error => this._$log.log(`SceneEdit [delete] failed. Scene was ${JSON.stringify(this.org)}. Error: ${error}`))
  }
}

export default {
  bindings: {
    id: '<?'
  },
  controller: SceneEditController,
  template: require('./scene-edit.component.html').default
}
